"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tabs = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var classnames_1 = require("../util/classnames");
var custom_prop_types_1 = __importDefault(require("../util/custom-prop-types"));
var vdl_prefix_1 = require("../util/vdl-prefix");
var tab_1 = require("./tab");
var _1 = require("../util/_");
var widget_helpers_1 = require("../util/widget-helpers");
var interaction_1 = require("../util/interaction");
var data_helpers_1 = require("../util/data-helpers");
var localizers_1 = require("../util/localizers");
var optionId = function optionId(id, idx) {
  return id + "__tab__" + idx;
};
function localizedMessage(messageKey, locale) {
  return localizers_1.message.formatMessage('adp-react-components/tabs/' + messageKey, undefined, locale);
}
function msgs(msgs, locale) {
  return Object.assign({
    emptyTabs: localizedMessage('EMPTY_TABS', locale)
  }, msgs);
}
var Tabs = /** @class */function (_super) {
  __extends(Tabs, _super);
  function Tabs(props) {
    var _this = _super.call(this, props) || this;
    //FIXME @widgetEditable
    _this.onChange = function (item) {
      var valueField = _this.props.valueField;
      if (!data_helpers_1.valueMatcher(item, _this.props.value, _this.props.valueField)) {
        widget_helpers_1.notify(_this.props.onChange, data_helpers_1.dataValue(item, valueField));
        _this.setState({
          selectedItem: item
        });
      }
    };
    var _a = _this.props,
      value = _a.value,
      data = _a.data,
      valueField = _a.valueField;
    var initialIdx = data_helpers_1.dataIndexOf(data, value, valueField);
    _this.state = {
      selectedItem: data[initialIdx] || data[0]
    };
    return _this;
  }
  Tabs.prototype.componentWillReceiveProps = function (props) {
    var value = props.value,
      data = props.data,
      valueField = props.valueField;
    var idx = data_helpers_1.dataIndexOf(data, value, valueField);
    this.setState({
      selectedItem: data[idx]
    });
  };
  Tabs.prototype.render = function () {
    var _a, _b, _c, _d, _e;
    var _this = this;
    var _f = this.props,
      orientation = _f.orientation,
      data = _f.data,
      children = _f.children,
      textField = _f.textField,
      valueField = _f.valueField,
      idField = _f.idField,
      disabled = _f.disabled,
      TabComponent = _f.tabComponent,
      ItemComponent = _f.itemComponent,
      LastTabComponent = _f.lastTabComponent;
    var messages = msgs(this.props.messages);
    var selectedItem = this.state.selectedItem;
    var id = widget_helpers_1.instanceId(this);
    var tabsClasses = (_a = {}, _a[vdl_prefix_1.vdlPrefix('tabs')] = true, _a[vdl_prefix_1.vdlPrefix('tabs--' + orientation)] = true, _a);
    var tabsContainerClasses = (_b = {}, _b[vdl_prefix_1.vdlPrefix('tabs__container')] = true, _b[vdl_prefix_1.vdlPrefix('tabs__container--' + orientation)] = true, _b);
    var tabToolbarClasses = (_c = {}, _c[vdl_prefix_1.vdlPrefix('tabs__toolbar')] = true, _c[vdl_prefix_1.vdlPrefix('tabs__toolbar--' + orientation)] = true, _c);
    var toolbarContainerClasses = (_d = {}, _d[vdl_prefix_1.vdlPrefix('tabs__toolbar__container')] = true, _d[vdl_prefix_1.vdlPrefix('tabs__toolbar__container--' + orientation)] = true, _d);
    var tabsContentClasses = (_e = {}, _e[vdl_prefix_1.vdlPrefix('tabs__content')] = true, _e[vdl_prefix_1.vdlPrefix('tabs__content--' + orientation)] = true, _e);
    var tabs = !data.length ? [react_1.default.createElement(TabComponent, {
      key: 'tab_0',
      empty: true,
      disabled: disabled,
      role: "note"
    }, _1.result(messages.emptyTabs, this.props))] : data.map(function (item, idx) {
      var currentId = optionId(id, idx);
      var isDisabled = interaction_1.isDisabledItem(item, _this.props);
      return react_1.default.createElement(TabComponent, {
        key: 'tab_' + idx,
        id: data_helpers_1.dataId(item, idField) || currentId,
        index: idx,
        dataItem: item,
        disabled: isDisabled,
        orientation: orientation,
        selected: interaction_1.contains(item, selectedItem, valueField),
        onSelect: _this.onChange
      }, ItemComponent ? react_1.default.createElement(ItemComponent, {
        item: item,
        disabled: isDisabled
      }) : data_helpers_1.dataText(item, textField));
    });
    if (this.props.lastTabComponent && orientation === 'horizontal') {
      tabs.push(react_1.default.createElement(LastTabComponent, null));
    }
    return react_1.default.createElement("div", {
      className: classnames_1.classNames(tabsClasses)
    }, react_1.default.createElement("div", {
      className: classnames_1.classNames(tabsContainerClasses)
    }, react_1.default.createElement("div", {
      className: classnames_1.classNames(tabToolbarClasses)
    }, react_1.default.createElement("ul", {
      className: classnames_1.classNames(toolbarContainerClasses)
    }, tabs)), react_1.default.createElement("div", {
      className: classnames_1.classNames(tabsContentClasses)
    }, children)));
  };
  Tabs.propTypes = {
    //-- controlled props -----------
    value: prop_types_1.default.any,
    onChange: prop_types_1.default.func,
    //------------------------------------
    data: prop_types_1.default.array,
    tabComponent: custom_prop_types_1.default.elementType,
    itemComponent: custom_prop_types_1.default.elementType,
    orientation: prop_types_1.default.oneOf(['horizontal', 'vertical']),
    valueField: custom_prop_types_1.default.accessor,
    textField: custom_prop_types_1.default.accessor,
    idField: custom_prop_types_1.default.accessor,
    children: prop_types_1.default.node,
    className: prop_types_1.default.string,
    role: prop_types_1.default.string,
    messages: prop_types_1.default.shape({
      emptyTabs: custom_prop_types_1.default.message
    }),
    disabled: prop_types_1.default.bool,
    disabledItems: prop_types_1.default.array,
    lastTabComponent: custom_prop_types_1.default.elementType
  };
  Tabs.defaultProps = {
    tabComponent: tab_1.Tab,
    orientation: 'horizontal',
    data: [],
    role: 'tablist',
    disabled: false
  };
  return Tabs;
}(react_1.default.Component);
exports.Tabs = Tabs;